/**
 * Montants : saisie texte (virgule ou point acceptés pendant l’édition).
 * post[field] est toujours un number ou null — comme en JSON / float API (séparateur décimal « . »).
 * Brouillon (montantEditDraft) pour conserver des saisies intermédiaires type « 120, ».
 */
export default {
  data () {
    return {
      montantEditDraft: {}
    }
  },
  methods: {
    /** Affichage aligné sur le modèle numérique (point décimal, même rendu que l’API JSON). */
    formatMontantFromModel (value) {
      if (value === null || value === undefined || value === '') {
        return ''
      }
      const n = Number(value)
      if (isNaN(n)) {
        return ''
      }
      return String(n)
    },
    montantDisplay (field) {
      if (this.montantEditDraft && Object.prototype.hasOwnProperty.call(this.montantEditDraft, field)) {
        return this.montantEditDraft[field]
      }
      return this.formatMontantFromModel(this.post[field])
    },
    onMontantFieldFocus (field) {
      this.$set(this.montantEditDraft, field, this.formatMontantFromModel(this.post[field]))
    },
    onMontantTextInput (field, raw) {
      const str = raw === null || raw === undefined ? '' : String(raw)
      this.$set(this.montantEditDraft, field, str)
      if (str.trim() === '') {
        this.post[field] = null
        return
      }
      const n = this.parseDecimalString(str)
      if (n !== null) {
        this.post[field] = n
      }
    },
    onMontantFieldBlur (field) {
      const raw = this.montantEditDraft[field]
      this.$delete(this.montantEditDraft, field)
      if (raw === undefined || raw === null || String(raw).trim() === '') {
        this.post[field] = null
        return
      }
      const n = this.parseDecimalString(raw)
      this.post[field] = n !== null ? n : null
    },
    parseDecimalString (raw) {
      if (raw == null) {
        return null
      }
      let s = String(raw).trim()
      if (s === '') {
        return null
      }
      s = s.replace(/[\s\u00a0\u202f]/g, '')
      if (s === '') {
        return null
      }
      const hasComma = s.indexOf(',') !== -1
      const hasDot = s.indexOf('.') !== -1
      if (hasComma && !hasDot) {
        s = s.replace(',', '.')
      } else if (hasComma && hasDot) {
        const lastComma = s.lastIndexOf(',')
        const lastDot = s.lastIndexOf('.')
        if (lastComma > lastDot) {
          s = s.replace(/\./g, '').replace(',', '.')
        } else {
          s = s.replace(/,/g, '')
        }
      }
      const n = parseFloat(s)
      return isNaN(n) ? null : n
    }
  }
}
